export const GET_REGISTRATION_FORM = 'REGISTRATION_FORMS/GET_REGISTRATION_FORM'
export const GET_REGISTRATION_FORM_FAILED = 'REGISTRATION_FORMS/GET_REGISTRATION_FORM_FAILED'
export const GET_REGISTRATION_FORM_SUCCESS = 'REGISTRATION_FORMS/GET_REGISTRATION_FORM_SUCCESS'

export const CREATE_REGISTRATION_FORM = 'REGISTRATION_FORMS/CREATE_REGISTRATION_FORM'
export const CREATE_REGISTRATION_FORM_FAILED = 'REGISTRATION_FORMS/CREATE_REGISTRATION_FORM_FAILED'
export const CREATE_REGISTRATION_FORM_SUCCESS = 'REGISTRATION_FORMS/CREATE_REGISTRATION_FORM_SUCCESS'

export const UPDATE_REGISTRATION_FORM = 'REGISTRATION_FORMS/UPDATE_REGISTRATION_FORM'
export const UPDATE_REGISTRATION_FORM_FAILED = 'REGISTRATION_FORMS/UPDATE_REGISTRATION_FORM_FAILED'
export const UPDATE_REGISTRATION_FORM_SUCCESS = 'REGISTRATION_FORMS/UPDATE_REGISTRATION_FORM_SUCCESS'

export const DOWNLOAD_REGISTRATION_FORM = 'REGISTRATION_FORMS/DOWNLOAD_REGISTRATION_FORM'
export const DOWNLOAD_REGISTRATION_FORM_FAILED = 'REGISTRATION_FORMS/DOWNLOAD_REGISTRATION_FORM_FAILED'
export const DOWNLOAD_REGISTRATION_FORM_SUCCESS = 'REGISTRATION_FORMS/DOWNLOAD_REGISTRATION_FORM_SUCCESS'

export const SEND_REGISTRATION_FORM = 'REGISTRATION_FORMS/SEND_REGISTRATION_FORM'
export const SEND_REGISTRATION_FORM_FAILED = 'REGISTRATION_FORMS/SEND_REGISTRATION_FORM_FAILED'
export const SEND_REGISTRATION_FORM_SUCCESS = 'REGISTRATION_FORMS/SEND_REGISTRATION_FORM_SUCCESS'

export const REMOVE_REGISTRATION_FORM = 'REGISTRATION_FORMS/REMOVE_REGISTRATION_FORM'
export const REMOVE_REGISTRATION_FORM_FAILED = 'REGISTRATION_FORMS/REMOVE_REGISTRATION_FORM_FAILED'
export const REMOVE_REGISTRATION_FORM_SUCCESS = 'REGISTRATION_FORMS/REMOVE_REGISTRATION_FORM_SUCCESS'

export const CLEAR_REGISTRATION_FORM = 'REGISTRATION_FORMS/CLEAR_REGISTRATION_FORM'
